import { ResponsiveTableRow, Row } from '@fs/zion-ui'
import React, { useContext } from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { usePageTitle } from '../../app/PageTitleContext'
import usePersonCopies from '../../../hooks/usePersonCopies'
import { PersonLink } from '../../app/Links'
import { PersonContext } from '../PersonContext'
import { PermissionsContext } from '../../app/PermissionsContext'
import CreateCopyButton from './CreateCopyButton'
import OwnerId from '../../common/OwnerId'

export default function PersonCopies() {
  usePageView({ page_detail: 'DMConsole:PersonCopies' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.person.copies'))
  const { currentPerson } = useContext(PersonContext)
  const { isRole } = useContext(PermissionsContext)
  const personId = currentPerson.id
  const { personCopies, refetchPersonCopies } = usePersonCopies(personId)
  const isPublic = currentPerson?.metadata.badges.some((badge) => badge.value?.value === 'Public')
  const currentPersonIsCopy = personCopies?.some((copy) => copy.copyPersonId === currentPerson.id)

  if (!personCopies) {
    return null
  }
  return (
    <>
      <Row>
        <span growX>
          {t('person.copy.hasCopies', 'This person has {count} copies', {
            count: personCopies.length,
          })}
        </span>
        {isRole('Data Admin 6') && !isPublic && !currentPersonIsCopy && (
          <CreateCopyButton refetchPersonCopies={refetchPersonCopies} />
        )}
      </Row>
      {personCopies.length > 0 && (
        <DmcResponsiveTable
          id="personCopiesTable"
          totalColumnCount={5}
          atSizeColumns={{
            default: {
              labels: [
                t('person.copy.personId', 'Copy Person ID'),
                t('person.copy.personName', 'Copy Person Name'),
                t('person.copy.copyOwnerId', 'Copy Owner ID'),
                t('person.copy.sourcePersonId', 'Source Person ID'),
                t('person.copy.sourceOwnerId', 'Source Owner ID'),
              ],
            },
          }}
        >
          {personCopies.map((row) => (
            <ResponsiveTableRow
              key={row.copyPersonId}
              column1={<PersonLink personId={row.copyPersonId} showDecodedId forward personName={row.copyPersonId} />}
              column2={row.copyPersonName}
              column3={<OwnerId ownerInfo={row.ownerData} />}
              column4={
                <PersonLink personId={row.sourcePersonId} showDecodedId forward personName={row.sourcePersonId} />
              }
              column5={<OwnerId ownerInfo={row.sourceOwnerData} />}
            />
          ))}
        </DmcResponsiveTable>
      )}
    </>
  )
}
